import { memo, type ReactNode } from "react";
import { Picker, type PickerItemProps } from "@design-system/Picker/Picker.lib";
import {
    EntityAvatar,
    type EntityAvatarEntity,
} from "@components/avatar/EntityAvatar";
import { getEntityAvatarName } from "@helpers/entityAvatarName";

export type PickerEntityItemEntity = EntityAvatarEntity;

export interface PickerEntityItemProps extends Omit<
    PickerItemProps,
    "children" | "leading"
> {
    entity: PickerEntityItemEntity;
    label?: ReactNode;
}

const PickerEntityItemImpl = ({
    entity,
    label,
    ...itemProps
}: PickerEntityItemProps) => (
    <Picker.Item
        {...itemProps}
        leading={<EntityAvatar entity={entity} size="xs" aria-hidden />}
    >
        {label ?? getEntityAvatarName(entity)}
    </Picker.Item>
);

/**
 * Entity row for a `Picker`: 16px `EntityAvatar`, the entity name, and the
 * inline expand toggle when `expandable`. Memoised, so the avatar element it
 * builds does not bust `Picker.Item`'s memo while its own props hold.
 */
export const PickerEntityItem = memo(PickerEntityItemImpl);
